/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxCleanStudentsRouteController", (function iife() {
	"use strict";

	function CleanStudentsRouteController(
		$scope,

		NodeRepository,
		Node,
		student
	) {
		$scope.nodes = [];

		$scope.currentNode = null;
		$scope.isFindingStudents = false;
		$scope.isDeleting = false;
		$scope.noUserCriteria = true;
		$scope.students = [];

		NodeRepository.list().then(function success(response) {
			for (var i = 0; i < response.nodes.length; ++i) {
				var node = response.nodes[i];
				$scope.nodes.push(new Node(node));
			}
		});

		$scope.findDeletableStudents = function findDeleteableStudents() {
			if ($scope.isFindingStudents) {
				return;
			}

			$scope.successMessage = null;
			$scope.errorMessage = null;
			$scope.isFindingStudents = true;

			student.listDeletableStudents($scope.currentNode.id, $scope.noUserCriteria).then(function success(response) {
				$scope.students = response;
			}, function rejected(response) {
				$scope.errorMessage = response.data.msgs[0];
			}).finally(function final() {
				$scope.isFindingStudents = false;
			});
		};

		$scope.hasSelectedStudents = function hasSelectedStudents() {
			for (var i = 0; i < $scope.students.length; ++i) {
				if ($scope.students[i].selected) {
					return true;
				}
			}

			return false;
		};

		$scope.selectAll = function selectAll() {
			for (var i = 0; i < $scope.students.length; ++i) {
				$scope.students[i].selected = true;
			}
		};

		$scope.deleteStudents = function deleteStudents() {
			if ($scope.isDeleting) {
				return;
			}

			$scope.successMessage = null;
			$scope.errorMessage = null;
			$scope.isDeleting = true;

			var studentIds = [];

			for (var i = 0; i < $scope.students.length; ++i) {
				var studentItem = $scope.students[i];

				if (studentItem.selected) {
					studentIds.push(studentItem.id);
				}
			}

			student.batchDelete(studentIds, $scope.noUserCriteria).then(function success() {
				$scope.successMessage = "Deleted " + studentIds.length + " students.";
			}, function rejected(response) {
				$scope.errorMessage = response.data.msgs[0];
			}).finally(function final() {
				$scope.isDeleting = false;
			});
		};

		$scope.filterChanged = function filterChanged() {
			$scope.students = [];
		};
	}

	return CleanStudentsRouteController;
}()));
